var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showMergeTagsDropdown)?_c('merge-tags-dropdown',{attrs:{"emailTemplateFilter":_vm.templateType,"language":_vm.language},on:{"change":function($event){return _vm.insertMergeTag($event)}}}):_vm._e(),_c('textarea',{attrs:{"id":"summernote"},domProps:{"value":_vm.$attrs.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }